module.exports = __webpack_public_path__ + "static/media/bb.c0e63b7b.svg";